import { createSelector } from 'reselect';

import _omit from 'lodash/omit';

export const getAllDictionaries = ({ dictionaries }) => dictionaries.all.data;

export const getIsLoadingAll = ({ dictionaries }) => dictionaries.all.isLoading;

export const getDictionariesList = ({ dictionaries }) =>
  dictionaries.list.data.items;

export const getDictionariesListCount = ({ dictionaries }) =>
  dictionaries.list.data.count;

export const getIsLoadingList = ({ dictionaries }) =>
  dictionaries.list.isLoading;

export const getSortOptions = ({ dictionaries }) =>
  dictionaries.list.sortOptions;

export const getFilterOptions = ({ dictionaries }) =>
  dictionaries.list.filterOptions;

export const getPaginationOptions = ({ dictionaries }) =>
  dictionaries.list.paginationOptions;

export const getFilterParams = ({ dictionaries }) =>
  dictionaries.list.filterParams;

export const getArchivedFilterOptions = createSelector(
  getFilterOptions,
  filterOptions =>
    _omit(filterOptions.find(f => f.filterBy === 'archived'), [
      'filterBy',
      'label',
      'enabled',
    ]),
);

export const getFilterOptionsWithSelected = createSelector(
  getFilterOptions,
  getPaginationOptions,
  (filterOptions, paginationOptions) =>
    filterOptions.map(option => ({
      ...option,
      selected: option.archived === paginationOptions.archived,
    })),
);

export const getFilteredSortOptions = createSelector(
  getSortOptions,
  getPaginationOptions,
  (sortOptions, paginationOptions) =>
    sortOptions.map(option => ({
      ...option,
      selected: option.value === paginationOptions.ordering,
    })),
);

export const getSelectedFilterOption = createSelector(
  getFilterOptionsWithSelected,
  filterOptions => filterOptions.find(option => option.selected === true),
);

export const getSelectedSortOption = createSelector(
  getFilteredSortOptions,
  options => options.find(option => option.selected === true),
);

export const getDictionary = ({ dictionaries }) => dictionaries.show.data;

export const getIsAdding = ({ dictionaries }) => dictionaries.add.isLoading;

export const getIsShowing = ({ dictionaries }) => dictionaries.show.isLoading;

export const getIsDeleting = ({ dictionaries }) =>
  dictionaries.delete.isLoading;

export const getIsExporting = ({ dictionaries }) =>
  dictionaries.partialExport.isLoading;

export const getDictionaryIndex = createSelector(
  getDictionariesList,
  getDictionary,
  (list, item) => {
    const index = list.findIndex(({ id }) => id === item.id);

    return index === -1 ? 0 : index;
  },
);
